<template>
  <div class="headerBox">
    <div class="comboName">{{ name }}</div>
    <div class="whiteCircle"></div>
    <div class="yellowCircle circle-gradient"></div>
    <div style="display: flex; justify-content: center">
      <ComboProductImage
        :components="activeCombo.components"
        id="headerSelectImg"
      ></ComboProductImage>
    </div>
  </div>
</template>
<!--
TODO ??? magic numbers ???
:top und :left werte aus ComboProductImage (40/50) müssen für IngredientImageComposition wieder rückgangig gemacht werden
zusätzlich top und left aus .yellowCircle (420/-63)
offset top -420 siehe .yellowCircle unten - 40 + 420 > 380
offset left 63 siehe .yellowCircle unten - 50 - 63  > -113
-->
<script>
import ComboProductImage from "./ComboProductImage";
import { opacityAnimation, getTranslatedMenuName } from "@/utils/helpers";

export default {
  components: { ComboProductImage },
  props: ["activeCombo"],
  computed: {
    name() {
      return getTranslatedMenuName(this.$store, this.activeCombo);
    }
  },
  mounted() {
    const data = {
      from: 0,
      to: 1,
      step: 0.05
    };
    opacityAnimation("headerSelectImg", data);
  }
};
</script>
<style lang="scss" scoped>
.headerBox {
  height: var(--component_combo_headerSelectCombo_headerBox_height);
}
.whiteCircle {
  border-radius: 50%;
  background: var(--component_combo_headerSelectCombo_whiteCircle_background);
  position: absolute;
  top: -581px;
  left: -584px;
  width: 1166px;
  height: 1166px;
  padding-top: 350px;
  padding-left: 650px;
  z-index: 2;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.yellowCircle {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  top: -420px;
  left: 63px;
  width: 955px;
  height: 919px;
  position: absolute;
  border-radius: 50%;
  z-index: 3;
}
.comboName {
  color: var(--component_combo_headerSelectCombo_comboName_color);
  font-family: var(--component_combo_headerSelectCombo_comboName_font-family);
  font-size: var(--component_combo_headerSelectCombo_comboName_font-size);
  position: absolute;
  text-align: center;
  text-transform: var(--component_combo_headerSelectCombo_comboName_text-transform);
  top: var(--component_combo_headerSelectCombo_comboName_top);
  width: 100%;
  z-index: 100;
}
#headerSelectImg {
  opacity: 0;
}
.circle-gradient {
  background: var(--circle-gradient);
}
</style>
